import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Lock, Clock } from 'lucide-react';
import { FloatingSparkles } from './FloatingSparkles';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState(3600); // 1 hour in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  const features = ['Manual de la Manifestación (Valor: $27 USD)', 'Manual de A Vaga Productiva (Valor: $27 USD)', 'Manual de Códigos Sagrados (Valor: $27 USD)', 'BONUS: The Club - Suplementario (Valor: $47 USD)', 'Acceso inmediato y de por vida', 'Actualizaciones futuras gratuitas'];
  return <section id="pricing" className="py-24 bg-white" data-id="element-243">
      <div className="max-w-4xl mx-auto px-6" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="magic-glow bg-cream rounded-[2.5rem] p-8 md:p-12 lg:p-16 shadow-[0_0_40px_rgba(196,149,106,0.3)] border border-rosegold/40 relative overflow-hidden" data-id="element-245">
          <FloatingSparkles count={25} color="#D4849A" className="opacity-60" data-id="element-246" />

          {/* Decorative corner */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-rosegold/10 rounded-bl-full" data-id="element-247"></div>

          <div className="absolute top-4 left-4 w-10 h-10 diamond-spin drop-shadow-[0_0_6px_rgba(212,132,154,0.6)]" data-id="element-248">
            <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-249">
              <defs data-id="element-250">
                <linearGradient id="diamondGrad1a" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-251">
                  <stop offset="0%" stopColor="#F5E0E8" data-id="element-252" />
                  <stop offset="40%" stopColor="#D4849A" data-id="element-253" />
                  <stop offset="70%" stopColor="#E8B0C5" data-id="element-254" />
                  <stop offset="100%" stopColor="#A06080" data-id="element-255" />
                </linearGradient>
                <linearGradient id="diamondGrad1b" x1="0%" y1="0%" x2="0%" y2="100%" data-id="element-256">
                  <stop offset="0%" stopColor="#FFF5F8" stopOpacity="0.9" data-id="element-257" />
                  <stop offset="100%" stopColor="#D4849A" stopOpacity="0.3" data-id="element-258" />
                </linearGradient>
              </defs>
              <polygon points="50,5 90,35 75,90 25,90 10,35" fill="url(#diamondGrad1a)" stroke="#D4849A" strokeWidth="1" data-id="element-259" />
              <polygon points="50,5 90,35 50,35" fill="#FFF5F8" fillOpacity="0.5" data-id="element-260" />
              <polygon points="50,5 10,35 50,35" fill="#E8B0C5" fillOpacity="0.6" data-id="element-261" />
              <polygon points="50,35 90,35 75,90" fill="#D4849A" fillOpacity="0.4" data-id="element-262" />
              <polygon points="50,35 10,35 25,90" fill="#C97A94" fillOpacity="0.5" data-id="element-263" />
              <polygon points="50,35 75,90 25,90" fill="url(#diamondGrad1b)" data-id="element-264" />
              <polygon points="50,5 55,20 50,35 45,20" fill="white" fillOpacity="0.7" data-id="element-265" />
            </svg>
          </div>
          <div className="absolute bottom-4 right-4 w-10 h-10 diamond-spin drop-shadow-[0_0_6px_rgba(212,132,154,0.6)]" data-id="element-266">
            <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-267">
              <polygon points="50,5 90,35 75,90 25,90 10,35" fill="url(#diamondGrad1a)" stroke="#D4849A" strokeWidth="1" data-id="element-268" />
              <polygon points="50,5 90,35 50,35" fill="#FFF5F8" fillOpacity="0.5" data-id="element-269" />
              <polygon points="50,5 10,35 50,35" fill="#E8B0C5" fillOpacity="0.6" data-id="element-270" />
              <polygon points="50,35 90,35 75,90" fill="#D4849A" fillOpacity="0.4" data-id="element-271" />
              <polygon points="50,35 10,35 25,90" fill="#C97A94" fillOpacity="0.5" data-id="element-272" />
              <polygon points="50,35 75,90 25,90" fill="#FFF5F8" fillOpacity="0.3" data-id="element-273" />
              <polygon points="50,5 55,20 50,35 45,20" fill="white" fillOpacity="0.7" data-id="element-274" />
            </svg>
          </div>

          <div className="text-center mb-10 relative z-10" data-id="element-275">
            <h2 className="text-3xl md:text-4xl font-serif text-burgundy mb-4" data-id="element-276">
              Comienza tu transformación hoy
            </h2>
            <p className="text-lg text-taupe mb-8" data-id="element-277">
              Todo lo que necesitas para regular tu energía y alinear tu
              identidad en un solo lugar.
            </p>

            <div className="flex flex-col items-center justify-center mb-8" data-id="element-278">
              <span className="text-red-600 font-semibold line-through text-xl mb-2" data-id="element-279">
                Valor Total: $128 USD
              </span>
              <div className="flex items-start justify-center text-burgundy" data-id="element-280">
                <span className="text-2xl font-medium mt-2" data-id="element-281">$</span>
                <span className="text-6xl md:text-7xl font-serif font-bold" data-id="element-282">
                  11.97
                </span>
                <span className="text-xl font-medium mt-auto mb-2 ml-2" data-id="element-283">
                  USD
                </span>
              </div>
              <motion.div animate={{
              scale: [1, 1.05, 1],
              boxShadow: ['0 0 0 0 rgba(212, 132, 154, 0.4)', '0 0 0 10px rgba(212, 132, 154, 0)', '0 0 0 0 rgba(212, 132, 154, 0)']
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="mt-6 bg-rosegold/10 border border-rosegold/30 px-6 py-2 rounded-full" data-id="element-284">
                <span className="text-rosegold font-bold uppercase tracking-wider text-sm" data-id="element-285">
                  Oferta Especial por tiempo limitado
                </span>
              </motion.div>
            </div>

            <motion.div animate={{
            opacity: [0.8, 1, 0.8]
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="bg-red-50 border border-red-200 rounded-xl p-4 max-w-sm mx-auto mb-8 shadow-sm" data-id="element-286">
              <div className="flex items-center justify-center gap-2 text-red-600 mb-2" data-id="element-287">
                <Clock size={20} data-id="element-288" />
                <span className="font-semibold text-sm uppercase tracking-wider" data-id="element-289">
                  Esta oferta expira en:
                </span>
              </div>
              <div className="text-4xl font-serif font-bold text-red-600 tracking-widest" data-id="element-290">
                {formatTime(timeLeft)}
              </div>
            </motion.div>
          </div>

          <div className="bg-white rounded-2xl p-8 mb-10 shadow-sm relative z-10 pt-[3px] pb-[3px]" data-id="element-291">
            <h3 className="font-serif text-xl text-burgundy mb-6 text-center" data-id="element-292">
              Lo que te llevas hoy:
            </h3>
            <ul className="space-y-4" data-id="element-293">
              {features.map((feature, index) => <li key={index} className="flex items-center" data-id="element-294">
                  <CheckCircle2 className="text-rosegold mr-3 flex-shrink-0" size={20} data-id="element-295" />
                  <span className="text-taupe font-medium text-[12px]" data-id="element-296">
                    {feature}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="text-center relative z-10" data-id="element-297">
            <a href="https://pay.hotmart.com/B104808844T" target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-block w-full md:w-auto bg-rosegold text-white px-12 py-5 rounded-full font-medium hover:bg-rosegold/90 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5 mb-6 text-[16px]" data-id="element-298">
              Quiero el KIT
            </a>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-taupe" data-id="element-299">
              <div className="flex items-center" data-id="element-300">
                <ShieldCheck size={18} className="text-rosegold mr-2" data-id="element-301" />
                <span data-id="element-302">Garantía de 7 días</span>
              </div>
              <div className="flex items-center" data-id="element-303">
                <Lock size={18} className="text-rosegold mr-2" data-id="element-304" />
                <span data-id="element-305">Pago 100% Seguro</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}